module.exports = __webpack_public_path__ + "static/media/bz.f962cb25.svg";